import { heroModuleTranslations } from './modules/hero';
import { authModuleTranslations } from './modules/auth';
import { layoutModuleTranslations } from './modules/layout';
import { accountModuleTranslations } from './modules/account';
import { headerModuleTranslations } from './modules/header';
import { footerModuleTranslations } from './modules/footer';
import { adminModuleTranslations } from './modules/admin';
import { backofficeModuleTranslations } from './modules/backoffice';
import { rbacModuleTranslations } from './modules/rbac';
import { employeeModuleTranslations } from './modules/employee';
import { employeeInviteModuleTranslations } from './modules/employeeInvite';
import { commonModuleTranslations } from './modules/common';
import { storefrontModuleTranslations } from './modules/storefront';
import { publicModuleTranslations } from './modules/public';

export const translationsByModule = {
  common: {
    ...commonModuleTranslations,
  },
  hero: {
    ...heroModuleTranslations,
  },
  auth: {
    ...authModuleTranslations,
  },
  layout: {
    ...layoutModuleTranslations,
  },
  account: {
    ...accountModuleTranslations,
  },
  header: {
    ...headerModuleTranslations,
  },
  footer: {
    ...footerModuleTranslations,
  },
  admin: {
    ...adminModuleTranslations,
  },
  backoffice: {
    ...backofficeModuleTranslations,
  },
  rbac: {
    ...rbacModuleTranslations,
  },
  employee: {
    ...employeeModuleTranslations,
  },
  employeeInvite: {
    ...employeeInviteModuleTranslations,
  },
  storefront: {
    ...storefrontModuleTranslations,
  },
  public: {
    ...publicModuleTranslations,
  },
} as const;

